module.exports = __webpack_public_path__ + "img/findmyweather.6929222f.png";